
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsDocTypeGrid extends Serenity.EntityGrid<CsDocTypeRow, any> {
        protected getColumnsKey() { return CsDocTypeColumns.columnsKey; }
        protected getDialogType() { return CsDocTypeDialog; }
        protected getIdProperty() { return CsDocTypeRow.idProperty; }
        protected getInsertPermission() { return CsDocTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return CsDocTypeRow.localTextPrefix; }
        protected getService() { return CsDocTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();

            // buttons.push({
            //     title: "Download Card Reader",
            //     hint: "Download Card Reader Installer",
            //     cssClass: "download-cardreader-button", 
            //     icon: "fa-download",
            //     separator: true,
            //     onClick: () => {
            //         window.location.href = Q.resolveUrl("~/Services/Csi/DownloadCardReaderInstaller");
            //     }
            // })
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}